import { Box, SxProps, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

interface EnterToSendHintProps {
  sx?: SxProps;
  text?: string;
}

export default function EnterToSendHint({
  sx = [],
  text,
}: EnterToSendHintProps) {
  const { t } = useTranslation("ui-components-classroom\\EnterToSendHint");
  const additionalSx = Array.isArray(sx) ? sx : [sx];

  return (
    <Box
      sx={[
        {
          px: 20,
          pb: 12,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        },
        ...additionalSx,
      ]}
    >
      <Typography variant="caption" color="text.secondary">
        {text ?? t("Shift + Return to add a new line")}
      </Typography>
    </Box>
  );
}
